import React from "react";
import toast, {
  Toaster as ReactHotToaster,
  useToasterStore
} from "react-hot-toast";
import { TOAST_LIMIT } from "helpers/constants";

const Toaster = () => {
  const { toasts } = useToasterStore();

  React.useEffect(() => {
    toasts
      .filter((t) => t.visible)
      .filter((_, i) => i >= TOAST_LIMIT)
      .forEach((t) => toast.dismiss(t.id));
  }, [toasts]);

  return <ReactHotToaster />;
};

export default Toaster;
